import { Typography } from "@mui/material";
import { getFgPctColor, ShotType } from "./utils";

export default function ShotProfileCell({
  openMade,
  openAtt,
  lightMade,
  lightAtt,
  heavyMade,
  heavyAtt,
  shotType,
}: {
  openMade: number | null;
  openAtt: number | null;
  lightMade: number | null;
  lightAtt: number | null;
  heavyMade: number | null;
  heavyAtt: number | null;
  shotType: ShotType;
}) {
  const oM = openMade ?? 0;
  const oA = openAtt ?? 0;
  const lM = lightMade ?? 0;
  const lA = lightAtt ?? 0;
  const hM = heavyMade ?? 0;
  const hA = heavyAtt ?? 0;

  if (oA === 0 && lA === 0 && hA === 0) return "-";

  const totalMade = oM + lM + hM;
  const totalAtt = oA + lA + hA;
  const fgPct = (totalMade / totalAtt) * 100;
  const displayPct = Math.round(fgPct);

  const formatShot = (made: number, att: number): string => (att === 0 ? "-" : `${made}/${att}`);

  const slotStyle: React.CSSProperties = {
    display: "inline-block",
    width: 36,
    textAlign: "center",
    fontFamily: "monospace",
  };

  const bgColor = getFgPctColor(fgPct, totalAtt, shotType);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        lineHeight: 1.4,
        width: "100%",
      }}
    >
      <div>
        {totalMade}/{totalAtt}
{" "}
        <Typography
          component="span"
          sx={{
            color: "text.secondary",
            fontSize: "0.85em",
            bgcolor: bgColor,
            borderRadius: 0.5,
            px: 0.5,
          }}
        >
          {`${displayPct}%`}
        </Typography>
      </div>
      <Typography
        component="div"
        sx={{
          color: "text.secondary",
          fontSize: "0.85em",
          lineHeight: 1.2,
        }}
      >
        <span style={slotStyle}>{formatShot(oM, oA)}</span>
        {" | "}
        <span style={slotStyle}>{formatShot(lM, lA)}</span>
        {" | "}
        <span style={slotStyle}>{formatShot(hM, hA)}</span>
      </Typography>
    </div>
  );
}
